import { render, staticRenderFns } from "./airPortList.vue?vue&type=template&id=02a67576&scoped=true"
import script from "./airPortList.vue?vue&type=script&lang=js"
export * from "./airPortList.vue?vue&type=script&lang=js"
import style0 from "./airPortList.vue?vue&type=style&index=0&id=02a67576&prod&lang=less&scoped=true"
import style1 from "./airPortList.vue?vue&type=style&index=1&id=02a67576&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a67576",
  null
  
)

export default component.exports